import styled from 'styled-components';
import theme from '../../assets/styles/theme';
import Flex from '../Flex/Flex';

export const ItemsSelector = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
`;

export const Hr = styled.hr`
  border: 0;
  width: auto;
  margin: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-5']};
  background-color: ${theme.colors.neutral.border.weak};
  height: 1px;
`;

export const SelectAll = styled.div`
  padding: ${theme.spacing['spacing-5']};
  margin-top: ${theme.spacing['spacing-6']};
`;

export const CheckboxWrapper = styled(Flex)`
  align-items: center;
  padding: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-7']}
    ${theme.spacing['spacing-0']} ${theme.spacing['spacing-5']};
`;

export const Item = styled(Flex)`
  justify-content: flex-start;
  padding: ${theme.spacing['spacing-5']} ${theme.spacing['spacing-0']};
`;

export const Footer = styled.div`
  justify-content: center;
  width: 100%;
  display: flex;
  button:first-child {
    margin-right: ${theme.spacing['spacing-5']};
  }
`;

export const List = styled.ul`
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: ${theme.colors.neutral.bg.strong}
    ${theme.colors.neutral.bg.weak};

  &::-webkit-scrollbar {
    width: ${theme.spacing['spacing-2']};
    height: ${theme.spacing['spacing-6']};
  }
  &::-webkit-scrollbar-track {
    background: ${theme.colors.neutral.bg.weak};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.neutral.bg.strong};
    height: ${theme.spacing['spacing-6']};
    border-radius: ${theme.borderRadius['border-radius-1']};
    margin: ${theme.spacing['spacing-6']} ${theme.spacing['spacing-0']}
      ${theme.spacing['spacing-0']};
    padding: ${theme.spacing['spacing-6']} ${theme.spacing['spacing-13']}
      ${theme.spacing['spacing-5']} ${theme.spacing['spacing-13']};
  }
`;

export const SearchWrapper = styled.div`
  margin: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-6']};
`;

export const ItemSelectorNoItems = styled.div`
  margin-top: ${theme.spacing['spacing-13']};
  padding: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-6']};
`;
